module.exports = __webpack_public_path__ + "assets/images/project/menu/vietnam-thumb.jpg?v=63f144ef";